'use client';

import { type EdgeProps, useReactFlow } from '@xyflow/react';
import type { GraphNodeType } from './types';
import { getNodeColor } from './utils';
import { GradientEdge } from '../flow-graph-base/GradientEdge';

const FALLBACK_COLOR = 'var(--colors-lilac-8)';

export function CustomEdge(props: EdgeProps) {
  const { getNode } = useReactFlow();
  const sourceNode = getNode(props.source);
  const targetNode = getNode(props.target);

  const sourceColor = sourceNode
    ? getNodeColor(sourceNode.data?.type as GraphNodeType)
    : FALLBACK_COLOR;
  const targetColor = targetNode
    ? getNodeColor(targetNode.data?.type as GraphNodeType)
    : FALLBACK_COLOR;

  return (
    <GradientEdge
      {...props}
      sourceColor={sourceColor}
      targetColor={targetColor}
      labelHeight={80}
      labelMaxLines={5}
    />
  );
}
